import { reqHeader } from '../store/configureSolarApi';
import { requesterrorType, requestType } from '../store/requestTypes';

export function handleErrors(response) {
    if (!response.ok) {
        throw Error(response.statusText);
    }
    return response;
}

export function getRequestHeader(post) {
    reqHeader.method = "GET";
    
    if (post) {
        reqHeader.method = "POST";
    }

    return reqHeader;
}

const baseUrl = process.env.REACT_APP_IS_LOCAL_AUTH
    ? "http://localhost:42698/"
    : "";

export async function getClientConfiguration() {
    return await fetch(baseUrl + "api/ClientConfiguration", getRequestHeader(false))
        .then(handleErrors)
        .then(res => res.json())
        .then(json => {
            return json;
        })
        .catch(error => { return error })
}